import {
	type BuildRangeCondition,
	type Condition,
	ConditionType,
	type FeatureFlagCondition,
	type FeatureGateCondition,
	type GetFeatureFlagValue,
	type GetFeatureGateValue,
	type ProductData,
	type RemoteAction,
} from '../../../../common/types';

const isFeatureFlagConditionSatisfied = (
	getFeatureFlagValue: GetFeatureFlagValue,
	condition: FeatureFlagCondition,
) => condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);

const isFeatureGateConditionSatisfied = (
	getFeatureGateValue: GetFeatureGateValue | undefined,
	condition: FeatureGateCondition,
) =>
	getFeatureGateValue &&
	condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);

const isBuildInAffectedRangeV2 = (
	getBuildKey: () => string,
	getBuildInfoFromKey: (buildKey: string) => {
		buildNumber: number;
		buildType: string;
	},
	condition: BuildRangeCondition,
) => {
	try {
		const { buildNumber: currentBuildNumber, buildType: currentBuildType } =
			getBuildInfoFromKey(getBuildKey());

		const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } =
			getBuildInfoFromKey(condition.buildRange[0]);

		const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } =
			getBuildInfoFromKey(condition.buildRange[1]);

		if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) {
			return false;
		}

		if (
			firstAffectedBuildNumber <= currentBuildNumber &&
			currentBuildNumber <= lastAffectedBuildNumber
		) {
			return true;
		}
	} catch (error) {
		console.warn('error while parsing a build key', error);
	}
	return false;
};

export const isActionConditionSatisfied = (productData: ProductData, condition: Condition) => {
	switch (condition.type) {
		case ConditionType.buildRange:
			return isBuildInAffectedRangeV2(
				productData.getBuildKey,
				productData.getBuildInfoFromKey,
				condition as BuildRangeCondition,
			);

		case ConditionType.featureFlag:
			return isFeatureFlagConditionSatisfied(
				productData.getFeatureFlagValue,
				condition as FeatureFlagCondition,
			);
		case ConditionType.featureGate:
			return isFeatureGateConditionSatisfied(
				productData.getFeatureGateValue!,
				condition as FeatureGateCondition,
			);
		default:
			return false;
	}
};

export const shouldProcessRemoteAction = (remoteAction: RemoteAction) => remoteAction.enabled;
